
import { Component, Vue } from "vue-property-decorator";

import userRoutes from "@/api/routes/users";

import UserDelegate from "@/models/user/delegate";
import UserUser from "@/models/user/user";
import { IRouteMeta } from "@/router/interface";

@Component
export default class CDelegate extends Vue {
  private currentUser: IJWTUser | null = this.$store.state.currentUser;

  protected delegate: UserDelegate | null = null;

  protected available_users: UserUser[] = [];
  protected selected_user: UserUser | null = null;

  protected watchers: Function[] = [];

  protected async created() {
    this.watchers.push(
      this.$store.watch(
        state => state.currentUser,
        currentUser => {
          this.currentUser = currentUser;
        }
      )
    );

    await this.loadDelegate();
  }

  protected beforeDestroy() {
    this.watchers.forEach(unwatch => {
      unwatch();
    });
  }

  protected async showDelegateModal() {
    await this.loadAvailableUsers();

    this.$modal.show("DelegateUserModal");
  }

  protected hideDelegateModal() {
    this.selected_user = null;

    this.$modal.hide("DelegateUserModal");
  }

  protected showUnDelegateModal() {
    this.$modal.show("UnDelegateUserModal");
  }

  protected hideUnDelegateModal() {
    this.$modal.hide("UnDelegateUserModal");
  }

  protected async loadAvailableUsers() {
    return this.$api
      .get(userRoutes.delegates, {
        params: {
          section_id: (this.$router.currentRoute.meta! as IRouteMeta)
            .permissions?.[0]
        }
      })
      .then(({ data: res }: { data: UserUser[] }) => {
        this.available_users = res;
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }

  protected async loadDelegate() {
    return this.$api
      .get(userRoutes.delegate(this.currentUser?.id!), {
        params: {
          section_id: (this.$router.currentRoute.meta! as IRouteMeta)
            .permissions?.[0]
        }
      })
      .then(({ data: res }: { data: UserDelegate | null }) => {
        if (res) {
          this.delegate = res;
        }
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }

  protected async delegateUser() {
    if (!this.selected_user) {
      this.$notify({
        group: "notifications",
        type: "error",
        text: "Необходимо выбрать пользователя",
        speed: 500
      });

      return;
    }

    return this.$api
      .post(userRoutes.delegates, { delegate_id: this.selected_user.id })
      .then(({ data: res }: { data: UserDelegate }) => {
        this.delegate = res;

        this.hideDelegateModal();
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }

  protected async removeDelegate() {
    if (this.delegate) {
      return this.$api
        .destroy(userRoutes.delegate(this.delegate.id))
        .then(() => {
          this.delegate = null;
          this.selected_user = null;

          this.hideUnDelegateModal();
        })
        .catch(({ response: res }) => {
          this.$notify({
            group: "notifications",
            type: "error",
            text: res.data.error,
            speed: 500
          });
        });
    }
  }
}
